import { css } from "goober";
import { mobile, screenNot } from "clutch/src/Style/style.mjs";

import router from "@/__main__/router.mjs";
import { appURLs } from "@/app/constants.mjs";
import VideoAdTestPageRefs from "@/app/VideoAdTestPage.refs.jsx";
import { VIDEO_AD_CSS } from "@/feature-ads/global-video-ad.mjs";
// import { apexBenchmarkRefs, apexLegendSelectRefs } from "@/game-apex/refs.mjs";
// import { csgoBenchmarkRefs } from "@/game-csgo/refs.mjs";
import lolRefs from "@/game-lol/refs.mjs";
import tftRefs from "@/game-tft/refs.mjs";
import valRefs from "@/game-val/refs.mjs"; // valLoadingScreenRefs, // valBenchmarkRefs, // valAgentSelectRefs,
import { readCountryCode } from "@/util/use-country-code.mjs";

export const AD_VIEW_THRESHOLD = 0.5;

export const AD_HEIGHT = 250;
export const AD_HEIGHT_DOUBLE = 600;
export const AD_WIDTH = 300;
export const AD_MIN_RATIO = 0.55;
export const AD_MIN_WIDTH = Math.ceil(AD_WIDTH * AD_MIN_RATIO);

export const DISPLAY_AD_Z_INDEX = 11;
export const VIDEO_AD_Z_INDEX = 12; // above display, for viewability

export const DISPLAY_AD_CLASS = "display-ad";
export const SLOT_UNFILLED_CLASS = "slot-unfilled";

// For some reason, Google wants only one targeting value for all.
export const TARGETING_PLATFORM = "blitz-chrome";

// Adding some entropy here to discourage hardcoding
export const VIDEO_AD_CLASS = `video-ad-${(~~(
  Math.random() * Math.pow(2, 16)
)).toString(16)}`;

export const ADS_STATIC_CONFIG = `${appURLs.UTILS_STATIC}/rev/ads`;
export const ADS_BLACKLIST_CONFIG = `${appURLs.UTILS_STATIC}/rev/blacklist`;

export type VideoAdData = {
  _refKey?: string;
  pageMacro: string | null;
  width: number;
  aspectRatio: string;
  float: boolean;
  refresh: boolean;
};

export const VIDEO_AD_DEFAULT_DATA: VideoAdData = {
  pageMacro: null,
  width: 400,
  aspectRatio: "16 / 9",
  float: true,
  refresh: false,
};

// DOM cannot be the injection target due to the requirement to render null
// when this module is disabled.
// Therefore we will pass a DOM element that the page will render.
export const videoAdsMap = new Map<object, Partial<VideoAdData>>([
  [
    VideoAdTestPageRefs,
    {
      pageMacro: "video-ad-test",
      refresh: true,
    },
  ],
  // TODO: Decide if we are keeping loading screen ads, remove all references if not
  // [
  //   lolLoadingScreenRefs,
  //   {
  //     pageMacro: "pre-loading",
  //     preventClose: "true",
  //     width: 350,
  //   },
  // ],
  [
    lolRefs.inGameFeatures,
    {
      pageMacro: "in-game",
      refresh: true,
    },
  ],
  [
    tftRefs,
    {
      _refKey: "inGamePlacement",
      pageMacro: "in-game",
      refresh: true,
    },
  ],
  [
    valRefs,
    {
      _refKey: "inGamePlacement",
      pageMacro: "in-game",
      refresh: true,
    },
  ],
]);

type DestroyAdHook<O extends object = object> = [O, keyof O];

// map of ref and key to overwrite
export const destroyAdHooks = [
  [lolRefs, "onEnterChampionSelect"] satisfies DestroyAdHook<typeof lolRefs>,
  [lolRefs, "onBeginPostmatchTransition"] satisfies DestroyAdHook<
    typeof lolRefs
  >,
] as const;

export const cssAdStyles = () => css`
  ${screenNot(mobile)} {
    --snackbar-max-width: calc(
      min(100%, var(--sp-container)) - ${AD_WIDTH}px - var(--page-padding) * 2
    );
  }

  ${VIDEO_AD_CSS}
`;

export const cssIframeEvents = () => css`
  &:not(.is-focused) iframe {
    pointer-events: none;
  }
`;

export const isControlRegion = () => readCountryCode() === "IL"; // Israel
export const isControlRoute = () =>
  router.route.currentPath.startsWith("/lol/in-game");
export const shouldShowControlPlacement = () =>
  isControlRegion() && isControlRoute();
